import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import InputText from '../../../common/form/input-text'
import InputGroup from '../../../common/form/input-group'
import Label from '../../../common/form/label'
import KeyboardListener, {
  KeyCode,
  KeyBinding,
} from '../../../common/keyboard-listener'
import Button from '../../../common/button'
import SaveErrorModal from '../../../common/save-error-modal'

import type { AppDispatch } from '../../../../stores/ducks'
import * as fromScenes from '../../../../stores/ducks/scenes'

type Props = {
  onSave: () => void;
  onClose?: () => void;
  message?: string;
  placeholderTitle?: string;
};

function SaveDialog ({
  onSave,
  onClose,
  message,
  placeholderTitle
}: Props) {
  const initialTitle = placeholderTitle?.trim() || `Save ${new Date().toISOString().slice(0, 10)}`
  const dispatch = useDispatch<AppDispatch>()
  const [title, setTitle] = useState(initialTitle)
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false)

  const handleSubmit = async () => {
    try {
      dispatch(fromScenes.applyPendingExternalChanges())
      await dispatch(fromScenes.saveOrUpdateScene(null, title))
      onSave()
    } catch {
      setIsErrorModalOpen(true)
    }
  }

  const handleCancel = () => {
    setTitle(initialTitle)
    if (onClose) onClose()
  }

  return (
    <div data-testid="save-dialog">
      <h2 className="mt0">Save</h2>
      {message && <p>{message}</p>}
      <div className="relative">
        <InputGroup>
          <Label>Title</Label>
          <InputText
            focus
            value={title}
            placeholder={initialTitle}
            onChange={(value: string) => setTitle(value)}
          />
        </InputGroup>
      </div>
      <div className="flex justify-end items-end mt3">
        <Button onClick={handleCancel}>Cancel</Button>
        <Button btnType="primary" className="ml2" onClick={handleSubmit} disabled={!title.trim()}>
          Save
        </Button>
      </div>
      <KeyboardListener
        bindings={[
          KeyBinding(KeyCode.enter, handleSubmit),
          KeyBinding(KeyCode.esc, handleCancel),
        ]}
      />
      <SaveErrorModal
        isOpen={isErrorModalOpen}
        handleClose={() => setIsErrorModalOpen(false)}
      />
    </div>
  )
}

export default SaveDialog
